import React, { useState } from 'react';

function WelcomeBanner({ username = 'Training1324' }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleAvatarClick = (e) => {
    e.stopPropagation();
    if (isExpanded) {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  };

  const handleBackdropClick = () => {
    setIsExpanded(false);
  };

  return (
    <div className="welcome-banner-container">
      <div className="container-fluid px-3 py-3">
        <div 
          className={`welcome-banner-pill ${isExpanded ? 'expanded' : ''}`}
          onClick={handleAvatarClick}
        >
          {!isExpanded ? (
            <div className="welcome-banner-icon-only">
              <i className="bi bi-person-circle fs-1 text-white"></i>
            </div>
          ) : (
            <div className="welcome-banner-content">
              <div className="welcome-banner-avatar">
                <i className="bi bi-person-circle fs-1 text-white"></i>
              </div>
              <div className="welcome-banner-text">
                <div className="welcome-banner-greeting">Hi, {username} 👏</div>
                <div className="welcome-banner-message">Welcome Back</div>
              </div>
            </div>
          )}
        </div>
      </div>
      {isExpanded && (
        <div className="welcome-banner-backdrop" onClick={handleBackdropClick}></div>
      )}
    </div>
  );
}

export default WelcomeBanner;

